/**
 * Returns the base URL for the platform (cookie-auth MVC backend).
 *
 * In dev, returns '' so all requests go through the Vite proxy (which
 * spoofs the branded Origin/Referer and handles CORS).
 * In production, returns the absolute VITE_PLATFORM_URL.
 *
 * `import.meta.env.DEV` is also `true` under Vitest (MODE: "test"), but tests
 * run in Node without a Vite dev proxy, so a relative baseUrl would make
 * fetchBaseQuery hand a relative URL to `new Request()`, which throws outside
 * a browser. Only go relative for the actual dev server.
 */
export const platformUrl: string =
  import.meta.env.DEV && import.meta.env.MODE !== 'test'
    ? ''
    : (import.meta.env.VITE_PLATFORM_URL ?? '');
